/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lg_Companion_ActionInputs */

const en_lg_companion_action = /** @type {(inputs: Lg_Companion_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open the setup guide and extension package`)
};

const id_lg_companion_action = /** @type {(inputs: Lg_Companion_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buka panduan dan paket ekstensi`)
};

/**
* | output |
* | --- |
* | "Open the setup guide and extension package" |
*
* @param {Lg_Companion_ActionInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const lg_companion_action = /** @type {((inputs?: Lg_Companion_ActionInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lg_Companion_ActionInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_lg_companion_action(inputs)
	return en_lg_companion_action(inputs)
});